import { api } from "../../app/api.js";
import { store } from "../../app/store.js";
import { display_errors } from "../../helpers/forms.js";

export default {
    template: `
        <div class="background posters"></div>
        <div class="flexy-column">
            <div class="container">
                <h1>Confirming Email</h1>
        
                <p id="ConfirmLoading">Please wait...</p>
                <div id="ConfirmErrors" class="errors hidden"></div>
            </div>
        </div>
    `,

    $errors: null,
    $loading: null,

    onMount() {
        this.$loading = document.getElementById('ConfirmLoading');
        this.$errors = document.getElementById('ConfirmErrors');

        const urlParams = new URLSearchParams(window.location.search);

        api.post({
            url: '/auth/verify',
            data: {
                token: urlParams.get('t'),
            },
            success: (response) => {
                if (!response.auth.token) {
                    throw new Error('Token missing from response.');
                }

                response.auth.logged_in = true;

                store.set('auth', response.auth);
                store.set('services', response.services);
                store.set('user', response.user);

                const redirect = urlParams.get('redirect');
                if (redirect) {
                    window.history.pushState({}, "", redirect);
                } else {
                    window.history.pushState({}, "", "/");
                }

                window.dispatchEvent(new PopStateEvent('popstate'));
            },
            error: (response) => {
                store.clear('auth');
                store.clear('services');
                store.clear('user');

                this.$loading.classList.add('hidden');
                display_errors(this.$errors, response);
            },
        });
    },

    onUnmount() {},
}
